import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : ''
    }
  },

  async getPeriodesForEntreprise (credentials) {
    return axios.post('/entreprise/gestionnairedepenses', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async updatePeriode (credentials) {
    return axios.post('/administration/updatePeriode', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async deletePeriode (credentials) {
    return axios.post('/administration/deletePeriode', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async getDatesForPeriode (credentials) {
    return axios.post('/administration/getDatesForPeriode', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async createPeriode (credentials) {
    return axios.post('/administration/createPeriode', credentials, { headers: this.getHeaders(), withCredentials: true })
  }
}
